import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Generator from "./pages/Generator";
import InvoiceView from "./pages/InvoiceView";
import "./App.css";

function App() {
  return (
    <Router basename="/trademark-invoice">
      <Routes>
        <Route path="/" element={<Generator />} />
        <Route path="/invoice/:id" element={<InvoiceView />} />
      </Routes>
    </Router>
  );
}

export default App;
